import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/diet-settings/goalSettings/',
    redirectTo: '/diet-settings/goalSettings/weight',
  },
];

export default redirects;
